import React from "react";
import { RadioButton } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { VOLUME_STATUS } from "../../utils/volumeConstants";
import { VolumeStatusBadge } from "../common/VolumeStatusBadge";
import css from "./statusChoice.module.css";
export var LIBRARY_STATUS_BY_ACTION = {
    expected: "CREATED",
    received: "RECEIVED",
    missing: "OVERDUE",
    damaged: "DAMAGED",
};
export var LIBRARY_TARGETS = [
    {
        action: "expected",
        labelId: "ui-br-legaldeposits.periodicals.issue.dialog.expected",
    },
    {
        action: "received",
        labelId: "ui-br-legaldeposits.periodicals.issue.dialog.received",
    },
    {
        action: "missing",
        labelId: "ui-br-legaldeposits.periodicals.issue.dialog.missing",
    },
    {
        action: "damaged",
        labelId: "ui-br-legaldeposits.periodicals.issue.dialog.damaged",
    },
];
export var isLibraryAction = function (action) {
    return LIBRARY_TARGETS.some(function (target) { return target.action === action; });
};
export var actionForStatus = function (status) {
    switch (status) {
        case "CREATED":
            return "expected";
        case "RECEIVED":
        case "RECEIVED_AFTER_ENFORCEMENT":
            return "received";
        case "OVERDUE":
            return "missing";
        case "DAMAGED":
        case "DAMAGED_REPORTED":
            return "damaged";
        default:
            return null;
    }
};
export var DepositRecordStatusBadge = function (_a) {
    var status = _a.status;
    return (React.createElement(VolumeStatusBadge, { status: VOLUME_STATUS[status] }));
};
export var LibraryStatusChoice = function (_a) {
    var currentStatus = _a.currentStatus, selected = _a.selected, onSelect = _a.onSelect, radioName = _a.radioName;
    var formatMessage = useIntl().formatMessage;
    var currentAction = actionForStatus(currentStatus);
    return (React.createElement(React.Fragment, null, LIBRARY_TARGETS.map(function (_a) {
        var action = _a.action, labelId = _a.labelId;
        return (React.createElement(RadioButton, { key: action, name: radioName, label: action === currentAction ? (React.createElement("span", null,
                formatMessage({ id: labelId }),
                " ",
                React.createElement("span", { className: css.currentHint },
                    "(",
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.periodicals.issue.dialog.current-hint" }),
                    ")"))) : (formatMessage({ id: labelId })), checked: selected === action, onChange: onSelect(action) }));
    })));
};
